import * as types from 'modules/questionModels/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} State */
const initialState = false;

const isReady = () => true;

const reset = () => initialState;

export default createReducer(initialState, {
  [types.IS_DETAILS_READY]: isReady,
  [LOCATION_CHANGE]: reset,
});
